const SERVICES = [
  {
    icon: 'ri-wifi-line',
    title: 'Redes e Wi-Fi Empresarial',
    desc: 'Projetamos e implantamos redes robustas e Wi-Fi corporativo com cobertura total, velocidade e segurança.',
    features: [
      'Internet estável e rápida',
      'Cobertura Wi-Fi profissional',
      'Redes separadas (empresa, visitantes, IoT)',
      'Gerenciamento centralizado',
    ],
    color: 'from-green-900/20 to-transparent',
  },
  {
    icon: 'ri-microsoft-fill',
    title: 'Microsoft 365 & E-mail',
    desc: 'Implantação e suporte completo ao Microsoft 365 para sua equipe trabalhar com produtividade e segurança.',
    features: [
      'E-mail profissional com domínio',
      'OneDrive e colaboração em equipe',
      'Gestão e segurança de usuários',
      'Treinamento e suporte técnico',
      'Intranet para Empresas',
    ],
    color: 'from-blue-900/10 to-transparent',
  },
  {
    icon: 'ri-server-line',
    title: 'Servidores e Backup',
    desc: 'Configuração e gestão de servidores físicos e virtuais, com soluções de backup automático e seguro.',
    features: [
      'Servidor de arquivos organizado',
      'Backup automático e seguro',
      'Proteção contra perda de dados',
      'Monitoramento 24/7',
    ],
    color: 'from-purple-900/10 to-transparent',
  },
  {
    icon: 'ri-camera-line',
    title: 'Segurança e Monitoramento',
    desc: 'Sistemas de câmeras IP, controle de acesso e monitoramento integrado para proteger seu patrimônio.',
    features: [
      'Câmeras IP e acesso remoto',
      'Controle de acesso',
      'Integração com sua rede',
      'Gravação em nuvem ou local',
    ],
    color: 'from-red-900/10 to-transparent',
  },
];

const EXTRA_SERVICES = [
  { icon: 'ri-router-line', title: 'Firewall e VPN' },
  { icon: 'ri-hard-drive-line', title: 'Storage NAS' },
  { icon: 'ri-computer-line', title: 'Manutenção de Computadores' },
  { icon: 'ri-tools-line', title: 'Suporte Técnico' },
  { icon: 'ri-cpu-line', title: 'Cabeamento Estruturado' },
];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-brand-surface py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-neon-green text-xs font-bold tracking-widest uppercase mb-3 block">
            O que fazemos
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Soluções completas para sua empresa
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base">
            Do Wi-Fi ao servidor, cuidamos de toda a sua infraestrutura de TI com padrão profissional.
          </p>
        </div>

        {/* Main services */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className={`bg-brand-card border border-brand-border rounded-xl p-6 hover:border-neon-green/50 transition-all duration-300 group relative overflow-hidden`}
            >
              <div className={`absolute inset-0 bg-gradient-to-b ${service.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-green/10 rounded-xl mb-4 group-hover:bg-neon-green/20 transition-colors">
                  <i className={`${service.icon} text-neon-green text-2xl`} />
                </div>
                <h3 className="text-white font-bold text-sm mb-2 leading-snug">{service.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4">{service.desc}</p>
                <ul className="space-y-2">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-gray-400 text-xs">
                      <i className="ri-checkbox-circle-fill text-neon-green mt-0.5 flex-shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Extra Services */}
        <div className="border border-brand-border rounded-xl p-8">
          <p className="text-center text-gray-400 text-sm mb-6">Outros serviços que oferecemos</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {EXTRA_SERVICES.map((s) => (
              <div key={s.title} className="flex flex-col items-center gap-2 p-4 rounded-lg hover:bg-brand-card transition-colors cursor-default">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className={`${s.icon} text-neon-green text-xl`} />
                </div>
                <span className="text-gray-400 text-xs text-center">{s.title}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-400 text-sm mb-4">Precisa de uma solução personalizada?</p>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 bg-neon-green text-black font-bold px-7 py-3 rounded-md hover:bg-green-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-message-3-line" />
            Solicite um Orçamento
          </a>
        </div>
      </div>
    </section>
  );
}
